"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantMap = exports.useCheckoutState = exports.useCheckoutDispatch = exports.useCheckout = exports.twoStepCheckout = exports.threeStepCheckout = exports.standardCheckout = exports.CheckoutProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _UnreachableCaseError = require("@oberoninternal/travelbase-ds/entities/UnreachableCaseError");
var _react = _interopRequireWildcard(require("react"));
var _router = require("next/router");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const standardCheckout = exports.standardCheckout = ['CheckoutExtras', 'CheckoutDetails', 'CheckoutPayment', 'CheckoutConfirm'];
const twoStepCheckout = exports.twoStepCheckout = ['CheckoutPayment', 'CheckoutConfirm'];
const threeStepCheckout = exports.threeStepCheckout = ['CheckoutDetails', 'CheckoutPayment', 'CheckoutConfirm'];
const variantMap = exports.variantMap = {
  standard: standardCheckout,
  order: twoStepCheckout,
  email: twoStepCheckout,
  ticket: threeStepCheckout
};
const CheckoutStateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const CheckoutDispatchContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const initialState = {
  variant: 'standard',
  pages: {}
};
function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return _objectSpread(_objectSpread({}, state), action.state);
    case 'reset':
      return initialState;
    case 'setPage':
      {
        const {
          route,
          value
        } = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          pages: {
            [route]: {
              valid: value,
              visited: true
            }
          }
        });
      }
    case 'setPageVisited':
      {
        const {
          route
        } = action;
        return _objectSpread(_objectSpread({}, state), {}, {
          pages: {
            [route]: {
              valid: state.pages[route]?.valid ?? false,
              visited: true
            }
          }
        });
      }
    case 'init':
      return _objectSpread(_objectSpread({}, initialState), {}, {
        variant: action.variant
      });
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(action);
  }
}
const getVariant = query => {
  if (query.id) {
    return 'order';
  }
  if (query.cartId) {
    return 'email';
  }
  return 'standard';
};
const CheckoutProvider = ({
  children
}) => {
  const router = (0, _router.useRouter)();
  const {
    0: state,
    1: dispatch
  } = (0, _react.useReducer)(reducer, _objectSpread(_objectSpread({}, initialState), {}, {
    variant: getVariant(router.query)
  }));
  return __jsx(CheckoutStateContext.Provider, {
    value: state
  }, __jsx(CheckoutDispatchContext.Provider, {
    value: dispatch
  }, children));
};
exports.CheckoutProvider = CheckoutProvider;
const useCheckoutDispatch = () => {
  const dispatch = (0, _react.useContext)(CheckoutDispatchContext);
  if (!dispatch) {
    throw new Error('useCheckoutDispatch must be used within a CheckoutProvider');
  }
  const setPageValidity = (0, _react.useCallback)((route, value) => dispatch({
    value,
    route,
    type: 'setPage'
  }), [dispatch]);
  const reset = (0, _react.useCallback)(() => dispatch({
    type: 'reset'
  }), [dispatch]);
  const set = (0, _react.useCallback)(state => dispatch({
    type: 'set',
    state
  }), [dispatch]);
  const setPageVisited = (0, _react.useCallback)(route => dispatch({
    route,
    type: 'setPageVisited'
  }), [dispatch]);
  const init = (0, _react.useCallback)(variant => dispatch({
    type: 'init',
    variant
  }), [dispatch]);
  return {
    setPageValidity,
    reset,
    set,
    setPageVisited,
    init
  };
};
exports.useCheckoutDispatch = useCheckoutDispatch;
const useCheckoutState = () => {
  const context = (0, _react.useContext)(CheckoutStateContext);
  if (!context) {
    throw new Error('useCheckoutState must be used within a CheckoutProvider');
  }
  return context;
};
exports.useCheckoutState = useCheckoutState;
const useCheckout = () =>
// maybe seperate these in two exports, but may be a little verbose
[useCheckoutState(), useCheckoutDispatch()];
exports.useCheckout = useCheckout;